<template>
    <div class="auth">
        <!-- AUTH HEADER START -->
        <auth-header/>
        <!-- AUTH HEADER END -->

        <!-- AUTH CONTENT START  -->
        <div class="auth-content">
            <div class="auth-content__container"> 
                <!-- <transition name="fade"> -->
                    <router-view></router-view>
                <!-- </transition> -->
             </div>

            <div class="auth-image">
                <img src="@/assets/images/authCat.svg" alt="authCat">
            </div>
        </div>
        <!-- AUTH CONTENT END  --> 
    </div>
</template>

<script>
import authHeader from '@/components/base/headers/authHeader';

export default {
    components: {
        authHeader
    }
}
</script>

<style lang="scss">
.auth-content {
    width: 100%;
    background: linear-gradient(180deg, #82C677 23.86%, #5B9351 100%), #FFFFFF;
    min-height: calc(100vh - 70px);
    position: relative; 

    &__container {
        min-height: 640px;
    }
}

.auth-image {
    // position: absolute;
    // bottom: 0;
    width: 100%; 
    display: flex;
    justify-content: center;
}
</style>